
let env = {};

env.baseURL = 'https://api.punhus.it4d.com.br/api/v1/';
env.normalURL = 'https://api.punhus.it4d.com.br/';
env.mode = 'production';
env.reverbKey = 'hfag7tvkg0f3ebt6bhde';
env.reverbHost = 'ws.punhus.it4d.com.br';
env.reverbPort = null;
env.reverbScheme = 'https';

export default env
